import { forwardRef } from 'react'
import {
  Checkbox as ThemeUICheckbox,
  CheckboxProps as ThemeUICheckboxProps,
} from 'theme-ui'

export type CheckboxProps = ThemeUICheckboxProps & {}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ ...rest }, ref) => <ThemeUICheckbox ref={ref as any} {...rest} />
)
